import React from "react";
import { Modal } from "react-bootstrap";
import { BsShopWindow } from "react-icons/bs";
import "./CartDetailsComponent.css";
import { FaChevronDown } from "react-icons/fa";
import moment from "moment";

const CartDetailPayModal = ({
  paymentShow,
  setPaymentShow,
  combinePromoData,
  deliveryCharge,
  handleApplyPromo,
  applyButton,
  setApplyButton,
  handleRemovePromo,
  finalValue,
  totalValue,
  promoClickData,
  setShow,
  setFinalValue
}) => {
  const handleClosePay = () => {
    handleRemovePromo();
    setPaymentShow(false);
  };
  return (
    <div>
      <Modal
        show={paymentShow}
        onHide={handleClosePay}
        backdrop="static"
        className="payment_modal_promo"
      >
        <Modal.Header closeButton>
          <h5 className="modal-title claim-Product-main-heading">
            Buy Product
          </h5>
        </Modal.Header>
        <Modal.Body>
          <div className="claim-Product-container  align-items-center mb-2">
            <div className="Image-forModal-popup">
              <h5>
                <BsShopWindow className="house_icon" />
                Items Total <span>₹ {totalValue}</span>
              </h5>
            </div>
            <div className="claim-Product-Inner-container ml-3"></div>
          </div>
          {combinePromoData?.length ? (
            <div className="claim-Product-PromoCode-Container mb-4">
              <h3>Promo Codes</h3>
              {combinePromoData?.map((item) => {
                return (
                  <div className="promo-code-item  justify-content-between align-items-center mb-2">
                    <h4>
                      {item?.PromoCode}
                      <button
                        type="button"
                        className="promo_view_dtal_btn btn-sm relaunch-btn btn-info"
                      >
                        View Details{" "}
                        <FaChevronDown className="arrow_down_pro" />
                      </button>
                    </h4>
                    <div className="promo-code-details">
                      <p>{item?.Description}</p>
                      <p>Validity: {moment(item?.ToDate).format("YYYY-MM-DD")}</p>
                    </div>
                    {applyButton ? (
                      <button
                        type="button"
                        className="apply_btn btn-sm "
                        onClick={() => handleRemovePromo()}
                      >
                        Remove
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="apply_btn btn-sm "
                        onClick={() => handleApplyPromo(item)}
                      >
                        Apply
                      </button>
                    )}
                  </div>
                );
              })}
            </div>
          ) : null}

          <div className="claim-Product-container mb-2 mt-2">
            <h5>
              Items total{" "}
              <span>
                ₹{" "}
                {applyButton
                  ? Math.max(0, totalValue - (promoClickData?.MinAmount || 0))
                  : totalValue}
              </span>
            </h5>
          </div>
          <div className="claim-Product-container mb-2 mt-2">
            <h5>
              Delivery charge{" "}
              <span>₹ {deliveryCharge?.[0]?.DeliveryCharges}</span>
            </h5>
          </div>
          <hr className="Modal_hr-line" />
          <div className="Modal-total-section">
            <h5>
              Total
              <span>
                ₹{" "}
                {applyButton
                  ? finalValue
                  : totalValue + deliveryCharge?.[0]?.DeliveryCharges}
              </span>
            </h5>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="CheckoutButton"
            onClick={() => {

              setShow(true);
            }}
          >
            Checkout
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CartDetailPayModal;
